module.exports = __webpack_public_path__ + "static/media/fridge-dark-gray.17fc812d.svg";